import { FileContent, FileContentFactory, TaxIncomeCertificate } from "../"

export interface ModifyTaxIncomeCertificate {
    document: FileContent
    monthlyIncome: number
}

export class ModifyTaxIncomeCertificateFactory {
    static create(): ModifyTaxIncomeCertificate {
        return {
            document: FileContentFactory.create(),
            monthlyIncome: 0
        }
    }

    static from(taxIncomeCertificate: TaxIncomeCertificate): ModifyTaxIncomeCertificate {
        return {
            document: FileContentFactory.fromUrl(taxIncomeCertificate.document),
            monthlyIncome: taxIncomeCertificate.monthlyIncome
        }
    }
}
